import { AxiosError } from "axios";
import * as requests from "../../../requests/templates/requestCreators";
import { EwaThunk } from "../../types";
import * as actions from "../actions";
import { mapApiToDispatch } from "./utils";

let isFetching = false;
const fetchAllTemplatesMetadata =
  (): EwaThunk => async (dispatch, getState) => {
    if (isFetching) return;
    isFetching = true;

    dispatch(actions.requestFetchAllTemplatesMetadata());

    try {
      const response = await requests.fetchAllTemplatesMetadata();
      const allTemplatesMetadata = response.data;

      dispatch(
        actions.successFetchAllTemplatesMetadata(
          allTemplatesMetadata.map(mapApiToDispatch)
        )
      );
    } catch (e) {
      // error handling
      dispatch(
        actions.errorFetchAllTemplatesMetadata((e as AxiosError).response)
      ); // TODO: nějak to rozparsovat
    } finally {
      isFetching = false;
    }
  };

export default fetchAllTemplatesMetadata;
